
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-389cb396\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/root/workspace/platform-admin_Cbe5/src/style/theme.scss\",\"/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./layout.vue")
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-389cb396\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/root/workspace/platform-admin_Cbe5/src/style/theme.scss\",\"/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./layout.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./layout.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-389cb396\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./layout.vue"),
  /* scopeId */
  "data-v-389cb396",
  /* cssModules */
  null
)
Component.options.__file = "/root/workspace/platform-admin_Cbe5/src/view/layout.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] layout.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-389cb396", Component.options)
  } else {
    hotAPI.reload("data-v-389cb396", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/layout.vue
// module id = 1023
// module chunks = 30